<template>
  <div class="api-user-token">
    <div class="api-user-token-container">
      <h1 class="api-user-token-title">API User Token Created</h1>
      <p class="api-user-token-text"> {{ token }}</p>
      <div class="button-group-01">
        <VasionButton
          classProp="secondary"
          @vasionButtonClicked="copyApiUserToken()"
        >
          COPY
        </VasionButton>
        <VasionButton
          classProp="primary"
          @vasionButtonClicked="doneApiUserToken()"
        >
          DONE
        </VasionButton>
      </div>
    </div>
    <VasionSnackbar
      id="snackbar-api-user-token"
      ref="snackbarApiUserToken"
      :showSnackbarBool.sync="showSnackbar"
      :snackbarImage="snackbarImage"
      :snackbarSubTitle="snackbarSubTitle"
      :snackbarTitle="snackbarTitle"
    />
  </div>
</template>
<script>
export default {
  name: 'APIUserToken',
  components: {},
  props: {
    token: {
      type: String,
      default: '',
      required: true,
    },
  },
  data: function () {
    return {
      showSnackbar: false,
      snackbarImage: false,
      snackbarSubTitle: '',
      snackbarTitle: '',
    }
  },
  async created() {
    await new Promise(resolve => setTimeout(resolve, 350))
    if (this.token) this.copyApiUserToken()
  },
  methods: {
    async copyApiUserToken() {
      try {
        await navigator.clipboard.writeText(this.token)
      } catch (error) {
        console.error('copyApiUserToken', error)
        this.snackbarTitle = 'API User Token'
        this.snackbarSubTitle = 'Failed to copy API User Token to clipboard'
        this.snackbarImage = false
        this.showSnackbar = true
      }

      this.snackbarTitle = 'API User Token copied to clipboard'
      this.snackbarSubTitle = ''
      this.snackbarImage = true
      this.showSnackbar = true
    },
    doneApiUserToken() {
      this.$emit('done')
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@import '@/assets/css/light-theme-system-palette.scss';

.api-user-token {
  position: relative;
}

::v-deep .vasion-loading-indicator {
  height: unset;
}

.api-user-token-container {
  min-width: 280px;
  width: 360px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
}

.api-user-token-container > * {
  width: 100%;
}

.api-user-token-title {
  text-align: center;
  text-transform: capitalize;
  color: $on-surface-variant;
  font-family: $font-family-book;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  margin: 0px;
}

.api-user-token-text {
  color: $on-surface-variant;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
}
</style>
